"use client"

import { useEffect, useState } from "react"
import { Button, Card } from "antd"
import { EditOutlined, HomeOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import "bootstrap/dist/css/bootstrap.min.css"
import "antd/dist/reset.css"
import Header from "../Header"
import Sidebar from "../Sidebar"
import AddSchedule from "./AddSchedule"
import { getShifts } from "../../services/doctor/shift schedule/shift_schedule"
import dayjs from "dayjs"

export default function ManageShifts() {
  const [shifts, setShifts] = useState([])

  const [showAddSchedule, setShowAddSchedule] = useState(false)
  const[edShift, setEdShift] = useState(false)
  const [editingShift, setEditingShift] = useState(null)
  const [currentDays, setCurrentDays] = useState(null)
  const [loading, setLoading] = useState(true);

  
  const fetchShifts = async () => {
    try {
      const result = await getShifts();
      if (result.success) {
        console.log("Fetched Data:", result.data);
        const formData=result?.data;

        setShifts(formData);
      } else {
        console.error("Error:", result.error || "Failed to fetch shifts");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };

  function calculateSlotCount(startTime, endTime, slotDuration) {
    const format = 'hh:mm A';
    let start = dayjs(startTime, format);
    let end = dayjs(endTime, format);
    // Handle overnight shifts (e.g., 07:00 AM to 03:30 AM next day)
    if (end.isBefore(start)) {
      end = end.add(1, 'day');
    }
    const totalMinutes = end.diff(start, 'minute');
    const slotCount = Math.floor(totalMinutes / slotDuration);
    return slotCount;
  }

  const handleEditShift = (shiftId) => {
    setEditingShift(shiftId)
    setEdShift(true)
    setShowAddSchedule(true)
    
  }

  const handleDeleteShift = (shiftId) => {
    // setShifts(shifts.filter(shift => shift.id !== shiftId))
  }

  const handleCreateNewShift = () => {
    setEditingShift(null)
    setShowAddSchedule(true)
  }
  useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
      fetchShifts();
    }, [showAddSchedule]);

  return (
    <div>
      <Sidebar activeClassName="add-shedule" />
      {showAddSchedule ? (
        <AddSchedule 
          setEdShift={edShift}
          setEditingShift={editingShift}
          setShowAddSchedule={setShowAddSchedule}
        />
      ) : (
        <div className="page-wrapper-doctor">
          <div className="content">
            <div className="page-header">
              <b>
                <h3 className="page-title font-weight-bold">Doctor Schedule</h3>
              </b>
            </div>

            <div className="card">
              <div className="card-body d-flex">
                <div className="container mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h3 className="fw-bold" style={{ color: "#2e37a4" }}>
                         
                      </h3>
                      <p className="text-muted">
                        You can customize clinic schedule by Add/Edit shifts as
                        per your convenience
                      </p>
                    </div>
                    <Button
                      type="white"
                      style={{ color: "white", background: "#2e37a4" }}
                      size="large"
                      onClick={handleCreateNewShift}
                    >
                      Create Shift With New Set Of Days
                    </Button>
                  </div>

                  {shifts.map((shift) => (
                    <div
                      key={shift.id}
                      className="mb-4"
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        padding: "12px",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="mb-0">{shift?.days?.join(', ')}</h5>
                        
                      </div>

                      <Card
                        className="border rounded"
                        style={{
                          maxWidth: "350px",
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          padding: "6px",
                          margin: "0",
                        }}
                      >
                        <div className="d-flex align-items-center mb-1">
                          <div className="me-2">
                            <HomeOutlined
                              style={{
                                fontSize: "18px",
                                color: "#2e37a4",
                                border: "1px solid #2e37a4",
                                borderRadius: "4px",
                                padding: "4px",
                              }}
                            />
                          </div>
                          <div className="flex-grow-1">
                            <div style={{ fontSize: "12px", lineHeight: "1.2" }}>
                              {shift?.name} {shift.type}
                            </div>
                          </div>
                          <Button
                            type="text"
                            icon={<EditOutlined />}
                            aria-label="Edit shift"
                            style={{ padding: "0" }}
                            onClick={() => handleEditShift(shift)}
                          />
                        </div>

                        <div className="d-flex align-items-center ps-3 mb-1">
                          <div
                            className="flex-grow-1"
                            style={{ fontSize: "12px", lineHeight: "1.2" }}
                          >
                            {shift.start_time} - {shift.end_time}
                          </div>
                          <Button
                            type="text"
                            icon={<DeleteOutlined />}
                            aria-label="Delete shift"
                            style={{ padding: "0" }}
                            onClick={() => handleDeleteShift(shift.id)}
                          />
                        </div>

                        <div
                          className="ps-3 text-muted"
                          style={{ fontSize: "10px", lineHeight: "1.2" }}
                        >
                          {calculateSlotCount(shift?.start_time,shift?.end_time,shift?.slot_duration)} slots ({shift.slot_duration} mins each)
                          {shift.allow_online_booking && " • Online booking allowed"}
                        </div>
                      </Card>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}